/**
 * Registration Page Component
 *
 * Temporarily disabled — shows a "Coming Soon" message.
 */

import React from 'react'
import { Link } from 'react-router-dom'
import { Bot, Clock } from 'lucide-react'

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/Card'
import { logger, loggerUtils } from '../../utils/logger'

/**
 * RegisterPage Component
 *
 * Coming soon placeholder while registration is disabled
 */
export const RegisterPage: React.FC = () => {
  React.useEffect(() => {
    logger.info('Registration page loaded (coming soon)')
    loggerUtils.userAction('page_visit', 'register_page')
    document.title = 'Sign Up - CleverAct AI'

    return () => {
      logger.component('RegisterPage', 'unmount')
    }
  }, [])

  return (
    <div className="min-h-screen bg-background flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      {/* Header with Logo */}
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link
          to="/"
          className="flex items-center justify-center space-x-2 group"
        >
          <div className="h-10 w-10 rounded-lg bg-gradient-to-br from-primary to-emerald-500 p-[2px]">
            <div className="flex h-full w-full items-center justify-center rounded-[6px] bg-background">
              <Bot className="h-6 w-6 text-primary" />
            </div>
          </div>
          <span className="text-2xl font-bold text-foreground group-hover:text-foreground/80 transition-colors">
            CleverAct AI
          </span>
        </Link>

        <p className="mt-2 text-center text-sm text-muted-foreground">
          Build AI agents that actually do things
        </p>
      </div>

      {/* Coming Soon Card */}
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <Card className="shadow-lg">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
              <Clock className="h-7 w-7 text-primary" />
            </div>
            <CardTitle className="text-2xl font-bold text-foreground">
              Coming Soon
            </CardTitle>
            <CardDescription>
              Sign-ups are temporarily closed. We're getting everything ready for you.
            </CardDescription>
          </CardHeader>

          <CardContent className="text-center space-y-6">
            <p className="text-sm text-muted-foreground">
              Want early access? Reach out to us and we'll get you set up.
            </p>

            <a
              href="mailto:contact@cleveract.ai"
              className="inline-flex w-full items-center justify-center rounded-full bg-gradient-to-r from-primary to-emerald-500 px-6 py-3 text-sm font-medium text-white transition-opacity hover:opacity-90"
            >
              Request Early Access
            </a>

            <div className="pt-2">
              <p className="text-sm text-muted-foreground">
                Already have an account?{' '}
                <Link
                  to="/auth/login"
                  className="font-medium text-primary hover:text-primary/80 focus:outline-none focus:underline"
                >
                  Sign in
                </Link>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default RegisterPage
